import {O} from "web-vcore";
import {Vec2, Vec3} from "../../../../../../Utils/ThreeJS/VectorStructs.js";

export class MapDragInfo<ExtraData extends object = object> {
	constructor(data: PartialBy<MapDragInfo, "extras">, extras_fallback: ExtraData = {} as ExtraData) {
		Object.assign(this, data);
		this.extras ??= extras_fallback;
		
	}

	@O accessor button: number;
	@O accessor startPos_mouse: Vec2;
	@O accessor startPos_world: Vec3;
	@O accessor currentPos_mouse: Vec2;
	@O accessor currentPos_world: Vec3;
	/*@O endPos_mouse: Vec2|n;
	@O accessor endPos_world: Vec3|n;*/
	@O accessor extras: ExtraData;
}

/*export class MapDragInfo_WithDOM<ExtraData extends object = object> extends MapDragInfo<ExtraData> {
	constructor(data: PartialBy<MapDragInfo_WithDOM, "extras" | "dom">, extras_fallback: ExtraData = {} as ExtraData) {
		super(data, extras_fallback);
	}

	dom: HTMLDivElement|n;
}*/